<template>
    <router-view />
</template>

<script>
	
export default {
    name: "PQrController",
    props: {
        qrId: {
            type: String,
            default: ''
        }
    },
    created() {
        this.redirectToDetectTheme();
    },
    methods: {
        redirectToDetectTheme() {
            const params = {
                name: 'detect.theme',
                params: {
                    mapId: '79962313',
                    qrId: this.qrId
                }
            };

            this.$router.replace(params);
        }
    }
}
</script>